import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DocumentsComponent } from './documents/documents.component';


@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    NgxDatatableModule
  ],
  declarations: [
    DocumentsComponent
  ]
})
export class DocumentsModule { }



// WEBPACK FOOTER //
// ./src/app/documents/documents.module.ts